<!-- 个人采购订单 -->
<template>
   <div class='page_content'>
      <subComponents ref="showSelectData"></subComponents>
      <div class="page_content_top">
         <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
         <div class="page_content_top_line">
            <vSearch @searchData="searchData" @openSearch="openSearch" :getRequestData=getRequestData v-if="pageShowData.jurHead" :searchList=pageShowData.jurHead.jurconfigform></vSearch>
         </div>
      </div>
      <div class="page_content_center">
         <el-table ref="elTable" v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini">
            <el-table-column label="选择操作" width="90">
               <template slot-scope="scope">
                  <el-radio v-model="selectedIndex" :label="scope.row.index" border size="mini">
                     <i class="el-icon-thumb"></i>
                  </el-radio>
               </template>
            </el-table-column>
            <!-- 采购订单主表格 -->
            <el-table-column align="center" v-if="tableValye.isShow == 1" v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey" show-overflow-tooltip :prop="tableValye.entityField"
                             :min-width="tableValye.fieldWeight" :label="tableValye.showField">
               <template slot-scope="scope">
                  <el-tag size="mini" v-if="tableValye.entityField == 'isWms'">
                     {{ scope.row.isWms == 0 ? '否' : '是' }}
                  </el-tag>
                  <el-tag size="mini" v-else-if="tableValye.entityField == 'psomState'">
                     {{ $common.getIsGsp(tableValye.formatterContent, scope.row.psomState) }}</el-tag>
                  <span v-else-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">
                     {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                  </span>
                  <span v-else-if="tableValye.fieldType == 'dateTime' && scope.row[tableValye.entityField]">
                     {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                  </span>
                  <span v-else-if="tableValye.isRift == 1">
                     <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                scope.row[tableValye.entityField] }}</a>
                  </span>
                  <span v-else>
                     {{ scope.row[tableValye.entityField] }}
                  </span>
               </template>
            </el-table-column>
         </el-table>
      </div>
      <div class="page_content_bottom">
         <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <el-dialog title="质量复查" v-if="qualityShow" :visible.sync="qualityShow" width="600px">
         <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm" :inline-message="false" :show-message="false">
            <el-form-item label="验收结论" prop="pscadCheckcon" :rules="[{required: true,  trigger: ['blur','change']}]">
               <el-radio-group v-model="ruleForm.pscadCheckcon">
                  <el-radio-button label="合格">合格</el-radio-button>
                  <el-radio-button label="不合格">不合格</el-radio-button>
               </el-radio-group>
            </el-form-item>
            <el-form-item label="不合格原因" prop="refReason" v-if="ruleForm.pscadCheckcon=='不合格'" :rules="[{required: true,  trigger: ['blur','change']}]">
               <el-input type="textarea" :rows="2" v-model="ruleForm.refReason"></el-input>
            </el-form-item>
            <el-form-item label="处置措施" prop="disMeasures" v-if="ruleForm.pscadCheckcon=='不合格'" :rules="[{required: true,  trigger: ['blur','change']}]">
               <el-input type="textarea" :rows="2" v-model="ruleForm.disMeasures"></el-input>
            </el-form-item>
         </el-form>
         <div slot="footer" class="dialog-footer">
            <el-button @click="qualityShow = false">取 消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
         </div>
      </el-dialog>
      <!-- 自定义设计 -->
      <customDesign ref="customDesign"></customDesign>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue";
export default {
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
   },
   data() {
      //这里存放数据
      return {
         tableHeight: 0,
         getRequestData: {},
         returnData: {
            total: 0, // 总条数
            list: [],
         },
         selectedIndex: 0,
         buttonList: [],
         pageShowData: [],
         formDataList: [],
         seId: "",
         dialogTitle: "",
         seWidth: "",
         height: "",
         seTitle: "",
         DialogVisible: false,
         seType: "",
         smId: "",
         parentSearchData: {},
         sField: "",
         qualityShow: false,
         ruleForm: {
            disMeasures: "",
            pscadCheckcon: "",
            pscadId: "",
            refReason: "",
         }
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "getRequestData.smName": {
         handler: function (newValue, oldValue) {
            if (newValue == "") {
               this.getRequestData.smId = "";
            }
         },
         deep: true,
      },
   },
   //方法集合
   methods: {
      changeTime(val) {
         if (val) {
            var time = val + 24 * 60 * 60 * 1000 - 1;
            this.getRequestData.end = time;
         }
      },
      // 点击穿透字段 传参单号
      toDetail(orderId) {
         if (orderId) {
            // 设置为true 打开穿透组件首页
            var isPenetrate = true;
            // 设置缓存 存入点击单号
            this.resetSetItem("penetrateOrderId", orderId);
            // 与父级跨域通信 传递isPenetrate参数
            window.parent.postMessage(
               {
                  //向窗口发送MessageEvent消息
                  cmd: "returnFormJson",
                  params: { isPenetrate }, //参数
               },
               "*"
            );
         }
      },
      //检索带回数据
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            this.paramValue(val);
         }
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(",");
         arr.forEach((item) => {
            this.getRequestData[item] = val[item];
         });
      },
      getSeWidth(e) {
         console.log(e);
         this.seWidth = e + "%";
      },
      getWidth(e) {
         console.log(e);
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         console.log(e);
         this.seTitle = e;
      },
      getExtractName(e) {
         console.log(e);
         this.exTitle = e;
      },
      // 检索Id, 索引(表格中), 标识
      openSearch({ sId, index, type, sField }) {
         this.DialogVisible = true;
         this.seId = sId;
         this.sField = sField;
         this.parentSearchData[type] = this.getRequestData[type];
      },
      isShowData(name, value) {
         switch (name) {
            case "supplier":
               var dataInfo = sessionStorage.getItem("selectSupplierData");
               if (dataInfo) {
                  dataInfo = JSON.parse(dataInfo);
                  this.getRequestData.psomBuycus = dataInfo.smId;
                  this.getRequestData.smName = dataInfo.smName;
               }
               break;
         }
      },

      // 获取数据列表
      async getPageInfo() {
         var pathId = parent.getMenuInfo(this.$route.path);
         let responseData = await this.$http.getJur({ ids: [pathId.jurId] });
         if (responseData.status == 200) {
            this.pageShowData = responseData.result;
            var obj = {}
            if (this.pageShowData.jurHead) {
               obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
            } else {
               obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
            }
            for (const key in obj) {
               this.$set(this.getRequestData, key, obj[key])
            }
            this.formDataList = this.pageShowData.jurFormVoList;
            this.getDataList();
            this.getButtonList();
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      clear(val) {
         if (val) {
            var arr = val.split(",")
            arr.forEach(item => {
               this.$set(this.getRequestData, item, "")
            })
         }
      },
      // 动作集合
      actionSet(actionData) {
         console.log(actionData, this.buttonList)
         switch (actionData.actionType) {
            case 0:
               this.ruleForm = {
                  disMeasures: "",
                  pscadCheckcon: "合格",
                  pscadId: "",
                  refReason: "",
               }
               this.qualityShow = true
               break;
         }
      },
      submitForm(formName) {
         this.$refs[formName].validate(async (valid) => {
            if (valid) {
               this.ruleForm.pscadId = this.returnData.list[this.selectedIndex].pscadId
               const responseData = await this.$http.pschaquality(this.ruleForm)
               if (responseData.status == 200) {
                  this.$message({
                     type: 'success',
                     message: '操作成功!'
                  });
                  this.qualityShow = false
                  this.getDataList()
               } else {
                  this.$message({
                     message: responseData.message,
                     type: 'error'
                  });
               }
            } else {
               this.$message.error("请完善必填项")
               return false;
            }
         });
      },
      openFormDesign() {
         console.log(this.pageShowData);
         let pathInfo = parent.getMenuInfo(this.$route.path)
         this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
      },
      showPrintPlan() {
         if (this.multipleSelection.length != 1) {
            this.$message({
               message: "请先选中一条操作数据",
               type: "error",
            });
            return false;
         }
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            var info = this.multipleSelection[0];
            this.$refs.printPlan.openDia(info.psomId);
         } else {
            return;
         }
      },
      // 数据搜索
      searchData() {
         this.getRequestData.page = 1;
         this.getDataList();
      },
      // 数据翻页
      setDataPageNumber(val) {
         this.getRequestData.page = val;
         this.getDataList();
      },

      // 切换显示条数
      setDataPageSize(val) {
         this.getRequestData.page = 1;
         this.getRequestData.rows = val;
         this.getDataList();
      },

      // 获取数据列表
      async getDataList() {
         let responseData = await this.$http.pschaqueryWaitQuality(
            this.getRequestData
         );
         if (responseData && responseData.status == 200) {
            let resData = JSON.parse(JSON.stringify(responseData));
            this.returnData.list = this.$common.getIndex(resData.result.list);
            this.returnData.total = resData.result.total;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      //获取状态
      getIsGsp(str, val) {
         try {
            str && str.replace(/\\/g, "");
            let arr = JSON.parse(str);
            let len = arr.length;
            let newStr = "";
            for (let i = 0; i < len; i++) {
               if (arr[i].key === val) {
                  newStr = arr[i].value;
                  break;
               }
            }
            return newStr;
         } catch (ex) {
            return str;
         }
      },
      // 获取按钮权限
      async getButtonList() {
         this.buttonList = await this.$common.getActionButton()
         
      },
// 监听键盘事件
      keyUp(e) {
         if (e.altKey && e.key === 'q') {
            // 阻止默认行为和事件冒泡
            e.preventDefault();
            e.stopPropagation();
            this.getDataList()
         }
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.getPageInfo();
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {
      addEventListener("keydown", this.keyUp); //创建监听键盘事件
      window.addEventListener('resize', () => { this.tableHeight = this.$common.getTableHeight() })
   },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
   beforeDestroy() {
      removeEventListener("keydown", this.keyUp);
      window.removeEventListener("resize", () => { this.tableHeight = this.$common.getTableHeight() })
   }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
   margin-right: 1rem;
}

.el-tabs--border-card_new {
   height: 85vh;
   overflow-y: scroll;
}

.el-drawer {
   outline: none;
}
</style>